import { AuthUser } from '../models/auth.models';
import { Log } from '../services/logger.service';

/**
 * The system-defined team name for participant (student) users.
 * Banners and other operator-only UI elements should be hidden for members of this team.
 */
export const PARTICIPANTS_TEAM_NAME = 'Participant';

/**
 * The system-defined team ID for participant (student) users.
 * Banners and other operator-only UI elements should be hidden for members of this team.
 */
export const PARTICIPANTS_TEAM_ID = '68c7a53a1c3f0937796d871b';

/**
 * The system-defined team name for management (admin) users.
 * Destructive operations such as entity archival are restricted to this team.
 */
export const MANAGEMENT_TEAM_NAME = 'Management Team';

/**
 * The system-defined team ID for the Management Team.
 * Must match the seed value in {@code InitialData/teams.json} and
 * {@code SeedAndInitWebApplicationExtensions.cs}.
 */
export const MANAGEMENT_TEAM_ID = '678f1a2b4e801adec6f18730';

/**
 * Returns `true` when the given user belongs to the `Participants` team.
 *
 * The check is intentionally case-sensitive to match the exact system-defined
 * team name stored on the user object. If the user is `null` or has no team
 * value, the function returns `false` so the banner remains visible (fail-open
 * toward operators).
 *
 * @param user - The currently authenticated user, or `null` when not signed in.
 */
export function isParticipant(user: AuthUser | null): boolean {
  return PARTICIPANTS_TEAM_NAME == user?.team
          && PARTICIPANTS_TEAM_ID == user?.teamId;
}

/**
 * Returns `true` when the given user belongs to the Management Team.
 *
 * The check mirrors the backend {@code ManagementTeamHandler}: both team name
 * and team ID must match the fixed system constants.
 *
 * @param user - The currently authenticated user, or `null` when not signed in.
 */
export function isManagementTeam(user: AuthUser | null): boolean {
  return MANAGEMENT_TEAM_NAME === user?.team
      && MANAGEMENT_TEAM_ID   === user?.teamId;
}
